import type { ProductDetail, Variant } from '../api/business/types';
import type { Translate } from '../i18n/translate';

/**
 * A product the back office shows variants for: one that varies by an option group, or sells more than one
 * variant. A simple product has one hidden variant and no variant UI at all (ADR-0010).
 */
export const isVariable = (product: Pick<ProductDetail, 'optionGroups' | 'variants'>): boolean =>
  product.optionGroups.length > 0 || product.variants.length > 1;

/** How a variant is named on screen: its values in axis order — "M / červená". */
export const variantLabel = (variant: Pick<Variant, 'optionValues'>, t: Translate): string =>
  variant.optionValues.length === 0
    ? t('variants.noValues')
    : variant.optionValues.map((value) => value.value).join(' / ');

/** The variants a new batch or a receipt may go to: the active ones. */
export const receivingVariants = (product: Pick<ProductDetail, 'variants'>): Array<Variant> =>
  product.variants.filter((variant) => variant.status === 'ACTIVE');
